import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loading from '../components/common/Loading';

const ProtectedRoute = ({ children }: any) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Show a loading spinner while the auth state is being checked
    return <Loading />;
  }

  if (!isAuthenticated) {
    // If not authenticated, redirect to the login page
    // Pass the current location so we can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If authenticated, render the child components (e.g., the Dashboard)
  return children;
};

export default ProtectedRoute;